/* CaniCatiCare 뉴스홈 — 조선일보 레이아웃 */

const S = {
  section: { fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, color: '#DD0000', fontSize: '11px' },
  hl: (sz = 15) => ({ fontFamily: 'Noto Serif KR, Georgia, serif', fontWeight: 700, color: '#1A1A1A', fontSize: `${sz}px`, lineHeight: 1.4, cursor: 'pointer' }),
  body: { fontFamily: 'Noto Sans KR, sans-serif', fontSize: '13px', color: '#555', lineHeight: 1.7 },
  byline: { fontFamily: 'IBM Plex Mono, monospace', fontSize: '10px', color: '#AAA' },
};

function Photo({ label, h, bg = '#1A1A1A' }) {
  return (
    <div style={{ height: h, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #E5E5E5' }}>
      <span style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '10px', color: 'rgba(255,255,255,0.25)' }}>{label}</span>
    </div>
  );
}

/* ─── 데이터 ────────────────────────────────── */

const centerHero = {
  section: '캐니캐티케어',
  hl: '"반려 동물의 지속 가능한\n내일을 위해"',
  sub: 'CaniCatiCare — 개와 고양이 모두를 위한 통합 동물 의료 플랫폼',
  byline: 'CaniCatiCare 편집팀 · 2024.11.27',
};

const centerSub = [
  {
    section: '건강검진',
    hl: '정기 건강검진으로 발견한 조기 암… 7살 말티즈 건강 되찾다',
    tag: 'CaniCatiCare 치료 사례',
  },
  {
    section: '24시간 응급',
    hl: '새벽 3시 경련 발작… 응급 처치가 골든타임을 지켰다',
    tag: 'CaniCatiCare 응급센터',
  },
  {
    section: '예방접종',
    hl: '고양이 범백혈구감소증, 예방접종 한 번으로 막을 수 있습니다',
    tag: 'CaniCatiCare 응급센터',
  },
];

const opinions = [
  { type: '칼럼', hl: '사료값보다 비싼 보호자의 불안, 정보가 답이다' },
  { type: '칼럼', hl: '동물병원 고르는 법, 가격보다 중요한 3가지 기준' },
  { type: '사설', hl: '반려동물 1500만 시대, 의료 인프라는 따라가고 있나' },
];

const columnists = [
  { col: '수의사 칼럼', hl: '노령견 관절염, 수술 없이 관리하는 방법', author: '김수의' },
  { col: '고양이 전문', hl: '고양이가 물을 안 마시는 진짜 이유', author: '이묘의' },
  { col: '영양 클리닉', hl: '비만 반려견을 위한 저칼로리 식단 설계', author: '박영양' },
  { col: '행동 교정', hl: '분리불안 강아지, 훈련보다 먼저 해야 할 것', author: '최훈련' },
  { col: '원장 에세이', hl: '"끝까지 함께"… 반려동물 호스피스 이야기', author: '정원장' },
];

/* ─── 컴포넌트 ────────────────────────────── */

export default function NewsHome() {
  return (
    <div className="max-w-7xl mx-auto px-6">
      <div className="flex flex-col md:flex-row" style={{ borderTop: '2px solid #1A1A1A' }}>

        {/* ── 중앙 컬럼 ─────────────────────── */}
        <div className="min-w-0 md:flex-1 md:border-r border-[#E5E5E5]" style={{ padding: '16px 16px 0' }}>

          {/* 히어로 기사 */}
          <div style={{ marginBottom: '20px', paddingBottom: '20px', cursor: 'pointer' }}>
            <Photo label="CaniCatiCare 반려동물 케어" h="480px" bg="#0A2A1A" />
            <div style={{ marginTop: '12px' }}>
              <span style={S.section}>■ {centerHero.section}</span>
              <h1 style={{ ...S.hl(28), margin: '6px 0 8px', letterSpacing: '-0.02em' }}>
                {centerHero.hl.split('\n').map((l, j) => <span key={j}>{l}{j === 0 && <br />}</span>)}
              </h1>
              <p style={{ fontFamily: 'Noto Serif KR, serif', fontStyle: 'italic', fontSize: '14px', color: '#555', marginBottom: '8px' }}>
                {centerHero.sub}
              </p>
              <p style={S.byline}>{centerHero.byline}</p>
            </div>
          </div>
        </div>

        {/* ── 우측 컬럼 (오피니언 + 광고) ──── */}
        <div className="md:w-[230px] md:flex-shrink-0 border-t md:border-t-0 border-[#E5E5E5]" style={{ paddingLeft: '16px', paddingTop: '16px' }}>

          {/* 오피니언 헤더 */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px', paddingBottom: '8px', borderBottom: '2px solid #1A1A1A' }}>
            <span style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '15px', color: '#1A1A1A' }}>전문가 칼럼</span>
            <a href="/#" style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '11px', color: '#888', textDecoration: 'none' }}>더보기 ›</a>
          </div>

          {/* 칼럼 사설 */}
          {opinions.map((o, i) => (
            <div key={i} style={{ paddingBottom: '8px', marginBottom: '8px', borderBottom: '1px solid #F0F0F0', cursor: 'pointer' }}>
              <span style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '11px', color: '#DD0000' }}>{o.type}</span>
              <p style={{ ...S.hl(12), marginTop: '3px', lineHeight: 1.5 }}>{o.hl}</p>
            </div>
          ))}

          {/* 칼럼니스트 */}
          <div style={{ borderTop: '1px solid #E5E5E5', paddingTop: '10px', marginTop: '4px' }}>
            {columnists.map((c, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 0', borderBottom: i < columnists.length - 1 ? '1px solid #F0F0F0' : 'none', cursor: 'pointer' }}>
                <div style={{ flex: 1 }}>
                  <p style={{ fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '10px', color: '#888', marginBottom: '3px' }}>{c.col}</p>
                  <p style={{ ...S.hl(12), lineHeight: 1.4 }}>{c.hl}</p>
                </div>
                <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: '#E8F4E8', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #C8E8C8' }}>
                  <span style={{ fontSize: '16px' }}>🩺</span>
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginTop: '16px', border: '1px solid #DDD', overflow: 'hidden', cursor: 'pointer' }}>
            <div style={{ background: '#0A3A2A', padding: '20px 16px', textAlign: 'center' }}>
              <p style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '9px', color: 'rgba(255,255,255,0.35)', letterSpacing: '0.15em', marginBottom: '8px' }}>ADVERTISEMENT</p>
              <p style={{ fontFamily: 'Noto Serif KR, serif', fontWeight: 900, fontSize: '16px', color: 'white', lineHeight: 1.4, marginBottom: '4px' }}>CaniCatiCare</p>
              <p style={{ fontFamily: 'Noto Sans KR, sans-serif', fontSize: '11px', color: 'rgba(255,255,255,0.65)', marginBottom: '12px', lineHeight: 1.6 }}>반려 동물의 지속 가능한<br />내일을 위해</p>
              <div style={{ background: '#DD0000', color: 'white', fontFamily: 'Noto Sans KR, sans-serif', fontWeight: 700, fontSize: '12px', padding: '8px 0' }}>
                지금 예약하기 →
              </div>
            </div>
            <p style={{ fontFamily: 'IBM Plex Mono, monospace', fontSize: '9px', color: '#BBB', textAlign: 'right', padding: '3px 6px', borderTop: '1px solid #EEE' }}>AD</p>
          </div>

        </div>
      </div>
    </div>
  );
}
